// components/PaginationControls.js
import React from "react";
import { Pagination } from "@themesberg/react-bootstrap";
import { useTranslation } from "react-i18next";
const PaginationControls = ({ totalPages, currentPage, onPageChange }) => {
   const { t } = useTranslation();
  if (totalPages <= 1) return null;

  const items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => onPageChange(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    // <Pagination className="justify-content-center mt-3">
    //   <Pagination.Prev
    //     onClick={() => onPageChange(currentPage - 1)}
    //     disabled={currentPage === 1}
    //   />
    //   {items}
    //   <Pagination.Next
    //     onClick={() => onPageChange(currentPage + 1)}
    //     disabled={currentPage === totalPages}
    //   />
    // </Pagination>

    <Pagination className="justify-content-center mt-3">
      <Pagination.Prev
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        {t('claimModalsTranslations.pagination.previous')}
      </Pagination.Prev>
      {items}
      <Pagination.Next
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        {t('claimModalsTranslations.pagination.next')}
      </Pagination.Next>
    </Pagination>

  );
};

export default PaginationControls;
